import { useEffect, useState } from "react";
import { Card, ListGroup, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";

import DstButton from "../../../../components/DstButton/DstButton";
import { useSession } from "../../../../contexts/SessionContext";
import translate from "../../../../services/Translate";
import { SavedUrl } from "./SaveUrls.d";
import {
  allowDrop,
  getDragIndex,
  loadSavedUrls,
  persistSavedUrls,
  removeByUrl,
  reorderSavedUrls,
  setDragData,
} from "./SaveUrls.function";

const SavedUrls = () => {
  const { language } = useSession();
  const [savedUrls, setSavedUrls] = useState<SavedUrl[]>([]);

  useEffect(() => {
    setSavedUrls(loadSavedUrls());
  }, []);

  if (savedUrls.length === 0) return null;

  return (
    <Card className="mb-4 shadow-sm">
      <Card.Header as="h3">{translate(language, "PAGES.HOME.SAVED_URLS.TITLE")}</Card.Header>
      <ListGroup variant="flush">
        {savedUrls.map((entry, index) => (
          <ListGroup.Item
            key={entry.url || index}
            className="d-flex justify-content-between align-items-center"
            draggable
            onDragStart={(event) => setDragData(event, index)}
            onDragOver={allowDrop}
            onDrop={(event) => {
              allowDrop(event);
              const fromIndex = getDragIndex(event);
              if (fromIndex === null || fromIndex === index) return;

              setSavedUrls((prev) => {
                const updated = reorderSavedUrls(prev, fromIndex, index);
                persistSavedUrls(updated);
                return updated;
              });
            }}
          >
            <div className="d-flex align-items-center">
              <span
                role="img"
                aria-label={translate(language, "PAGES.HOME.SAVED_URLS.REORDER")}
                title={translate(language, "PAGES.HOME.SAVED_URLS.REORDER")}
                className="me-2"
              >
                <span className="dst-icon-dots-grid clickable" />
              </span>

              <OverlayTrigger placement="right" overlay={<Tooltip>{entry.url}</Tooltip>}>
                <Link to={entry.url} className="text-decoration-none">
                  {entry.name}
                </Link>
              </OverlayTrigger>
            </div>

            <div className="d-flex gap-2 ms-3">
              <DstButton
                value=""
                variant="outline-danger"
                clickFunction={() =>
                  setSavedUrls((prev) => {
                    const updated = removeByUrl(prev, entry.url);
                    persistSavedUrls(updated);
                    return updated;
                  })
                }
                tooltip={translate(language, "PAGES.HOME.SAVED_URLS.BUTTON_DELETE")}
                tooltipPosition="left"
                btnImageBefore={<span className="dst-icon-trash-01" />}
              />
            </div>
          </ListGroup.Item>
        ))}
      </ListGroup>
    </Card>
  );
};

export default SavedUrls;
